import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as OT from '@opentok/client';
import { UtilsService } from '../../services/utils/utils.service';
import { EnvironmentService } from '../../services/enviroment/environment.service';
import { StartRecordSolicitude } from './opentok.model';
import { Room } from '../../models';
import { ApiService } from '../api.service';
import { API_CALL_TOKBOX_URL } from './apiCallTokboxUrl.constants';

@Injectable({
  providedIn: 'root'
})
export class ApiTokboxService extends ApiService {
  session?: OT.Session ;
  token?: string;
  public roomData?: Room;
  private API_KEY: any;

  constructor(
    utils: UtilsService,
    private readonly environmentService: EnvironmentService,
    private readonly http: HttpClient
  ) {
    super(utils);
    this.API_KEY = environmentService.data.tokbox.API_KEY;
  }

  getOT() {
    return OT;
  }

  initSession(roomData: Room): Promise<OT.Session> {
    const config = this.environmentService.data.tokbox;
    this.session = this.getOT().initSession(config.API_KEY, roomData.providedId, {
      iceConfig: {
        includeServers: 'all',
        transportPolicy: 'relay',
        customServers: []
      },
    });
    this.token = roomData.token;
    return Promise.resolve(this.session);
  }

  connect(): Promise<OT.Session> {
    return new Promise((resolve, reject) => {
      if (!this.session) {
        reject('error: no session');
      } else{
        this.session.connect(this.token as string, (err: any) => {
          if (err) {
            reject(err);
          } else {
            resolve(this.session as OT.Session);
          }
        });
      }
      });
  }

  startRecord(resolution: string): Observable<any> {
    const obj: StartRecordSolicitude = {
      sessionId: this.roomData?.providedId || '',
      resolution: resolution,
    };

    const apiInstance = this.getApiInstance(API_CALL_TOKBOX_URL.START_VIDEORECORDING);
    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);

    return this.http.post(url, obj);
  }

  StopRecord(archiveId: string): Observable<any> {
    const apiInstance = this.getApiInstance(API_CALL_TOKBOX_URL.STOP_RECORDING);
    apiInstance.params['archiveId'].value = archiveId;

    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);

    return this.http.post(url, {});
  }

  // TODO: CUANDO SONIA TENGA EL MICRO QUE LISTA TODOS LOS ARCHIVOS, LO DESCOMENTAMOS Y BORRAMOS EL ANTERIOR.
  listArchives(): Observable<any> {
    const apiInstance = this.getApiInstance(API_CALL_TOKBOX_URL.LIST_ARCHIVES);
    apiInstance.params['providedId'].value = this.roomData?.providedId;


    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);

    return this.http.get(url);
  }

  deleteArchive(archiveId: string): Observable<any> {
    const apiInstance = this.getApiInstance(API_CALL_TOKBOX_URL.DELETE_RECORDING);
    apiInstance.params['archiveId'].value = archiveId;

    const url = this.getApiUrl(this.environmentService.data.apiUrl, apiInstance);
    return this.http.delete(url);
  }
  
  promiseWithTimeout<T>(promise: Promise<T>,ms:number): Promise<T> {
    // create a promise that rejects in milliseconds
    const timeout = new Promise<never>((_, reject) => {
      setTimeout(() => {
        reject(new Error('Promise timed out'));
      },ms);
    });  
    // returns a race between timeout and the passed promise
    return Promise.race<T>([promise, timeout]);
  }

}
